import { render, staticRenderFns } from "./AnswerQuestions.vue?vue&type=template&id=d6f10440&"
import script from "./AnswerQuestions.vue?vue&type=script&lang=js&"
export * from "./AnswerQuestions.vue?vue&type=script&lang=js&"
import style0 from "./AnswerQuestions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports